import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const BootstrapQuery = graphql.persisted(
  "BootstrapQuery",
  graphql(`
    query BootstrapQuery {
      currentUser {
        id
        email
        appPortal {
          accessibleSchools {
            school {
              id
              name
              slug
            }
            roles
            accessibleSchoolYears {
              schoolYear {
                id
                name
                slug
                state
                startDate
                endDate
              }
              roles
            }
          }
        }
      }
    }
  `)
);

export { BootstrapQuery };

export function useBootstrapQuery() {
  return useQuery(BootstrapQuery);
}
